<div style="height: 400px; width: 100%; margin: auto">
  <canvas #lineChartRef></canvas>
</div>
